import { useTheme } from '@gravity-ui/uikit';
import { editor, KeyCode, KeyMod, languages, MarkerSeverity } from 'monaco-editor';

import { routes } from '../routes';

import { granetLanguageConfig } from './languages/granet/config';
import { granetSyntaxDefinition } from './languages/granet/syntax';

languages.register({ id: 'granet' });
languages.setMonarchTokensProvider('granet', granetSyntaxDefinition);
languages.setLanguageConfiguration('granet', granetLanguageConfig);

window.MonacoEnvironment = {
    getWorkerUrl: () => routes.app.assets('editor.worker.js', __appConfig.app.urlRoot),
};

/**
 * Monaco editor theme derived from the app theme. Monaco's `create` ignores the global theme on
 * mount, so each `<MonacoEditor>` must pass this as its `theme` prop. Maps `dark → vs-dark`,
 * everything else → `vs`.
 */
const getEditorTheme = (theme: string): string => (theme === 'dark' ? 'vs-dark' : 'vs');

/**
 * Read the Gravity UI theme and return the matching Monaco theme string. Pass straight to the
 * `theme` prop of `<MonacoEditor>`.
 */
export const useMonacoTheme = (): string => getEditorTheme(useTheme());

export { languages, editor, MarkerSeverity, KeyMod, KeyCode };
